(function () {
    "use strict";

    /**
     * Class that allows the website environment to be determined
     * @constructor
     */
    function Environment(environment) {
        this.getEnvironment = environment;
    }

    /**
     * @function gets the 'raw' site prefix
     * @param mockDocument - substitute for window.document
     * @returns {'www'|'web'|'net'|'local'}
     */
    Environment.prototype.getWebsiteEnvironmentPrefix = function (mockDocument) {
        var document;
        if (this.getEnvironment) {
            return this.getEnvironment();
        } else {
            document = mockDocument || window.document;
            //split the current url into pieces and get the first piece
            return document.location.hostname.split('.')[0];
        }
    };

    /**
     * @function Translates the environment prefix to the commonly used abbreviations
     * @returns {string} {'prod'|'uat'|'test'|'local'}
     */
    Environment.prototype.determineEnvironment = function () {
        //split the current url into pieces and get the first piece
        var subDomain = this.getWebsiteEnvironmentPrefix();

        //default to prod if demo
        //include domains used for unbounce landing pages and the application form, since they both use this code
        if (subDomain === 'demo' || subDomain === '' || subDomain === 'www' || subDomain === 'join' || subDomain === 'binaries' || subDomain === 'trade' || subDomain === 'demo-trade' || subDomain === 'ao' || subDomain === "website-prod"  || subDomain === "website-demo") {
            subDomain = 'prod';
        } else if (subDomain === "web" || subDomain === "web-ao" || subDomain === "web-trade" || subDomain === "website-uat") {
            subDomain = "uat";
        } else if (subDomain === "net" || subDomain === "net-ao" || subDomain === "net-trade" || subDomain === "website-test") {
            subDomain = "test";
        } else if (subDomain === 'localhost' || subDomain === 'lapkrk0043') {
            subDomain = 'local';
        }
        //console.log("nadex analytics: subdomain: ", subDomain);
        return subDomain;
    };

    window.nadex = window.nadex || {};
    window.nadex.marketing = window.nadex.marketing || {};
    window.nadex.marketing.analytics = window.nadex.marketing.analytics || {};
    window.nadex.marketing.analytics.environment = new Environment();
}());
